import React, { useEffect, useState, useCallback, useRef } from "react";
// import classes from "../assets/styles/CardFunctions.module.css";
import cardtype from "../assets/images/function_page_icons/cardtype.svg";
import cardname from "../assets/images/function_page_icons/cardname.svg";
import pictureicon from "../assets/images/function_page_icons/pictureicon.svg";
import company from "../assets/images/function_page_icons/company.svg";
import companylogo from "../assets/images/function_page_icons/companylogo.svg";
import userdetails from "../assets/images/function_page_icons/userdetails.svg";
import contactnumber from "../assets/images/function_page_icons/contactnumber.svg";
import socialmedialinks from "../assets/images/function_page_icons/socialmedialinks.svg";
import cardsuccess from "../assets/images/function_page_icons/cardsuccess.svg";
import crossicon from "../assets/images/global_icons/crossicon.svg";
import FormInput from "../components/Forms/FormInput";
import baseURL from "../utils/constants/baseUrl";
import Loader from "../components/Loader";
import { Link } from "react-router-dom";
import { IoDocumentTextSharp } from "react-icons/io5";
import { MdAddBox } from "react-icons/md";
import {
  FiMail,
  FiTrash2,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import { MdLocationOn } from "react-icons/md";
import { BsGlobe, BsImageFill } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import { BsArrowLeft } from "react-icons/bs";
import { BsFillPersonFill } from "react-icons/bs";

import {
  CardBackGroundImages,
  Colors,
  AddMoreCustomUrls,
} from "../utils/data/CardFunctionsData";
import PhoneInput from "react-phone-input-2";
import Modal from "react-bootstrap/Modal";
import "react-phone-input-2/lib/material.css";
import { useDropzone } from "react-dropzone";
import { SketchPicker } from "react-color";
import _ from "lodash";
import Card from "../components/PageComponents/Function/Card";
import showToast from "../helpers/showToast";
import { loggedInUser, teamIDCheck, subscribedPackage, accountType, teamLogoAtom } from "../utils/store";
import { useAtom } from "jotai";
import { Card_URL, THEME_GET } from "../utils/constants/apiUrl";
import { get, post } from "../server";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import uploadImage from "../helpers/uploadImage";
import { saveCardBrandingOverride } from "../utils/cardBrandingOverrides";
import ValidateSchema from "../helpers/ValidateSchema";
import Joi from "joi";
import Select from "../components/Select";
import { MdClose } from "react-icons/md";
import { useMemo } from "react";
import socialMediaLinksSchema from "../utils/SchemasValidation/ModalSocialMediaLinksSchema";
import loaderClasses from "../assets/styles/Loader.module.css";
import { formatUrl, validatePhoneWithCountryCode } from "../utils/functions";
import CropImageModal from "../components/Modals/CropImageModal";
import functionTypes from "../utils/constants/functionTypes";
import useFunctionsCount from "../hooks/useFunctionsCount";
import listViewImage from "../assets/images/function_page_icons/listview.svg";
import gridViewImage from "../assets/images/function_page_icons/gridview.svg";
import treeViewImage from "../assets/images/function_page_icons/treeview.svg";
import iconViewImage from "../assets/images/function_page_icons/iconview.svg";
import { FaRegRectangleList } from "react-icons/fa6";
import { LuLayoutGrid } from "react-icons/lu";
import { MdOutlineViewTimeline } from "react-icons/md";
import { TbIcons } from "react-icons/tb";
import { MdOutlineEdit } from "react-icons/md";
// import circle from "/circle.svg";
// import square from "../assets/images/function_page_icons/square.svg";
// import rectangular from "../assets/images/function_page_icons/rectangular.svg";
import {
  LoginSocialFacebook,
  LoginSocialInstagram,
} from "reactjs-social-login";
import { trackEvent } from "../utils/mixpanel";
import { Button } from "react-bootstrap";
const businessHeaderValues = {
  0: "<p class=tabNumber>01</p> Choose your Card Type",
  1: "<p class=tabNumber>02</p> Enter your Full Name",
  2: "<p class=tabNumber>03</p> Add your Company & Position",
  3: "<p class=tabNumber>04</p> Select Background",
  4: "<p class=tabNumber>05</p> Your card will look great with a Profile Picture",
  5: "<p class=tabNumber>06</p> Add your Company Logo",
  6: "<p class=tabNumber>07</p> Select your Theme Color",
  7: "<p class=tabNumber>08</p> Add more details about Yourself",
  8: "<p class=tabNumber>09</p> Add your Contact Number",
  9: "<p class=tabNumber>10</p> Add your Social Media Links",
  10: "<p class=tabNumber>11</p> Select Content View",
  11: '<p class=tabNumber>13</p> "Card" has been added to your Card Functions',
};

const personalHeaderValues = {
  0: "<p class=tabNumber>01</p> Choose your Card Type",
  1: "<p class=tabNumber>02</p> Enter your Full Name",
  2: "<p class=tabNumber>03</p> Select Background",
  3: "<p class=tabNumber>04</p> Your card will look great with a Profile Picture",
  // 3: "Add your <br /><strong>Profile Picture</strong>",
  4: "<p class=tabNumber>05</p> Select your Theme Color",
  5: "<p class=tabNumber>06</p> Add more details about Yourself",
  6: "<p class=tabNumber>07</p> Add your Contact Number",
  7: "<p class=tabNumber>08</p> Add your Social Media Links",
  8: "<p class=tabNumber>09</p> Select Content View",
  9: '<p class=tabNumber>10</p> "Card" has been added to your Card Functions',
};

const options = [
  { value: "personal", label: "Personal" },
  { value: "business", label: "Business" },
];

const pronounsOptions = [
  { value: "she/her", label: "She/Her" },
  { value: "he/him", label: "He/Him" },
  { value: "they/them", label: "They/Them" },
  { value: "custom", label: "Custom" },
];
const cardViewOptions = [
  { value: "list", label: "List", image: <FaRegRectangleList /> },
  { value: "grid", label: "Grid", image: <LuLayoutGrid /> },
  { value: "tree", label: "Tree", image: <MdOutlineViewTimeline /> },
  { value: "icon", label: "Icon", image: <TbIcons /> },
];
const imgShapeOptions = [
  { value: "circle", label: "Circle", image: "/images/circle.svg" },
  { value: "square", label: "Square", image: "/images/square.svg" },
  {
    value: "rectangular",
    label: "Rectangular",
    image: "/images/rectangular.svg",
  },
];

const tab0Schema = Joi.object({
  card_type: Joi.string().required().messages({
    "string.empty": `Please select a card type`,
  }),
});

const tab1Schema = Joi.object({
  first_name: Joi.string().max(25).trim().required().messages({
    "string.empty": `Please enter your first name`,
    "string.max": `First name can be max 25 characters long`,
  }),

  last_name: Joi.string().max(25).allow("").messages({
    "string.max": `Last name can be max 25 characters long`,
  }),
});

const moreDetailSchema = Joi.object({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .max(50)
    .allow("")
    .messages({
      "string.email": `Please enter valid email`,
      "string.max": `Email can be max 50 characters long`,
    }),

  city: Joi.string().max(50).allow("").messages({
    "string.max": `City can be max 50 characters long`,
  }),

  address: Joi.string().max(250).allow("").messages({
    "string.max": `Address can be max 250 characters long`,
  }),

  country: Joi.string().max(50).allow("").messages({
    "string.max": `Country can be max 50 characters long`,
  }),

  website_url: Joi.string()
    .pattern(
      new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%@_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%@_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
      )
    )
    .allow("")
    .messages({
      "string.pattern.base": `Please enter a valid url`,
    }),
});

const companyInfoSchema = Joi.object({
  company: Joi.string().max(50).allow("").messages({
    "string.max": `Company can be max 50 characters long`,
  }),

  company_position: Joi.string().max(50).allow("").messages({
    "string.max": `Company position can be max 50 characters long`,
  }),
});

const phoneNumberSchema = Joi.array().items(
  Joi.object({
    phone_number: Joi.string()
      .pattern(
        new RegExp(
          /^(?!\b(0)\1+\b)(\+?\d{1,3}[. -]?)?\(?\d{3}\)?([. -]?)\d{3}\3\d{4}$/
        )
      )
      .allow("")
      .messages({
        "string.empty": `Please enter your phone number`,
        "string.pattern.base": `Please enter a valid phone number`,
      }),
  })
);

const CardFunctions = ({ disabled = false }) => {
  const [cardFunction, setCardFunction] = useState({
    card_type: "",
    first_name: "",
    last_name: "",
    email: "",
    company: "",
    company_position: "",
    logo: "",
    background_image: "",
    profile_image: "",
    color: "",
    country_phone: "",
    phone_number: "",
    description: "",
    address: "",
    country: "",
    state: "",
    city: "",
    website_url: "",
    card_social_media: [],
    pronouns: "",
    card_phone: [],
    content_view_type: "",
    profile_image_shape: "",
    logo_shape: "",
  });
  const [selectedCardView, setSelectedCardView] = useState("list");
  const [profileImageShape, setProfileImageShape] = useState("circle");
  const [logoImageShape, setLogoImageShape] = useState("circle");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (location.state?.prefill) {
      const prefill = location.state.prefill;

      let formattedPhones = [];
      if (prefill.phones && Array.isArray(prefill.phones)) {
        formattedPhones = prefill.phones.map(phoneStr => ({
          phone_type: "mobile",
          country_phone: "",
          phone_number: phoneStr,
          custom_label: "",
          phone_extension: ""
        }));
      }

      setCardFunction((prev) => ({
        ...prev,
        first_name: prefill.first_name || prev.first_name,
        last_name: prefill.last_name || prev.last_name,
        email: prefill.email || prev.email,
        company: prefill.company || prev.company,
        company_position: prefill.company_position || prev.company_position,
        website_url: prefill.website || prefill.website_url || prev.website_url,
        address: prefill.address || prev.address,
        city: prefill.city || prev.city,
        state: prefill.state || prev.state,
        country: prefill.country || prev.country,
        card_phone: formattedPhones.length > 0 ? formattedPhones : prev.card_phone,
        card_type: prefill.card_type || prev.card_type || "business", // default to business if it came from OCR
      }));
    }
  }, [location.state]);

  // useEffect(() => {
  //   // Extract pathname segments
  //   const pathSegments = window.location.pathname.split("/");
  //   if (pathSegments.length > 1 && pathSegments[1] === "dynamicQRCode") {
  //     setDynamicQRCode(true); // 'dynamicQRCode'
  //   }
  // }, []);
  const handleCardViewChange = (view) => {
    setSelectedCardView(view);
    setCardFunction((prevCardFunction) => ({
      ...prevCardFunction,
      content_view_type:
        view === "list"
          ? "listDesign"
          : view === "grid"
            ? "gridDesign"
            : view === "tree"
              ? "treeDesign"
              : "iconDesign",
    }));
    setSelectedView(view);
  };

  const selectedStyleClass =
    selectedCardView === "list"
      ? "listDesign"
      : selectedCardView === "grid"
        ? "gridDesign"
        : selectedCardView === "tree"
          ? "treeDesign"
          : "iconDesign";

  const handleProfileShapeChange = (view) => {
    setProfileImageShape(view);
    setCardFunction((prevCardFunction) => ({
      ...prevCardFunction,
      profile_image_shape:
        view === "circle"
          ? "circle"
          : view === "square"
            ? "square"
            : "rectangular",
    }));
    setSelectedShape(view);
  };
  const handleLogoShapeChange = (view) => {
    setLogoImageShape(view);
    setCardFunction((prevCardFunction) => ({
      ...prevCardFunction,
      logo_shape:
        view === "circle"
          ? "circle"
          : view === "square"
            ? "square"
            : "rectangular",
    }));
    setSelectedLogoShape(view);
  };
  const selectedShapeClass =
    profileImageShape === "circle"
      ? "circle"
      : profileImageShape === "square"
        ? "square"
        : "rectangular";

  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [tabHeader, setTabHeader] = useState(personalHeaderValues[0]);
  const [totalTabCount, setTotalTabCount] = useState(0);

  const [customMediaLinkOpen, setCustomMediaLinkOpen] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [uploadImageOpen, setUploadImageOpen] = useState(false);
  const [colorPickerOpen, setColorPickerOpen] = useState(false);
  const [cardViewOpen, setCardViewOpen] = useState(true);

  const [modalMediaLinks, setModalMediaLinks] = useState([]);

  const [customColor, setCustomColor] = useState(false);
  const [customBackgroundImage, setCustomBackgroundImage] = useState(false);
  const [pendingTeamBackgroundChange, setPendingTeamBackgroundChange] =
    useState(null);
  const [pendingTeamColorChange, setPendingTeamColorChange] = useState(null);
  const [pendingTeamLogoChange, setPendingTeamLogoChange] = useState(false);
  const brandingOverridesRef = useRef({
    background_image: false,
    color: false,
    logo: false,
  });
  const updateTeamBackgroundRef = useRef(false);
  const updateTeamColorRef = useRef(false);
  const updateTeamLogoRef = useRef(false);
  const teamBackgroundUploadConfirmedRef = useRef(false);
  const teamLogoUploadConfirmedRef = useRef(false);

  const [imageUploadKey, setImageUploadKey] = useState("");

  const [errors, setErrors] = useState({});
  const [mediaLinkErrors, setMediaLinkErrors] = useState([]);

  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [fileData, setFileData] = useState("");
  const [crop, setCrop] = useState();
  const [showModal, setShowModal] = useState(false);
  const [cropType, setCropType] = useState("");

  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [personalAccount] = useAtom(accountType);

  const [teamLogoUrl] = useAtom(teamLogoAtom);
  const isTeamOwner = loggedUser?.role?.includes("team_owner") || false;
  const isTeamMode = !personalAccount;
  const teamBranding = loggedUser?.teams || null;

  // Pre-fill team branding for a team owner in team mode, or any team member.
  const shouldApplyTeamBranding = !!(teamBranding && ((isTeamOwner && isTeamMode) || !isTeamOwner));
  // Team owners may override these values per card. Team members inherit the
  // branding values and cannot change them in the card wizard.
  const isBrandingLocked = !isTeamOwner && !!teamBranding;

  // Team owner currently viewing their team card — allow custom upload only for background
  const isTeamOwnerInTeamMode = isTeamOwner && isTeamMode && !!teamBranding;
  // Keep the background step visible for team members; branding locks its controls.
  const hideBackground = false;
  // Team owners can add a custom background to both personal and team cards.
  const showCustomBackgroundUpload = isTeamOwner;
  // Keep the existing custom team-branding controls scoped to team mode.
  const showCustomBackgroundOnly = isTeamOwnerInTeamMode;

  useEffect(() => {
    if (!isTeamOwner || !isTeamMode || !loggedUser?.token) return;

    const loadCurrentTeamBranding = async () => {
      const { status, data } = await get(THEME_GET, loggedUser.token);
      if (status && data?.team) {
        setLoggedUser((prev) => ({
          ...prev,
          teams: {
            ...(prev.teams || {}),
            ...data.team,
          },
        }));
      }
    };

    loadCurrentTeamBranding();
  }, [isTeamOwner, isTeamMode, loggedUser?.token, setLoggedUser]);

  // Branding backgrounds may be stored as either a relative asset path or a
  // fully-qualified URL. Compare their paths so the persisted choice is still
  // highlighted when this read-only step is opened.
  const isSameBackground = (savedBackground, presetBackground) => {
    if (!savedBackground || typeof savedBackground !== "string") return false;

    const normalizePath = (value) => {
      try {
        return new URL(value, window.location.origin).pathname.replace(/^\/+/, "");
      } catch {
        return value.split("?")[0].split("#")[0].replace(/^\/+/, "");
      }
    };

    return normalizePath(savedBackground) === normalizePath(presetBackground);
  };

  const selectedBackgroundIsPreset = CardBackGroundImages.some(({ img }) =>
    isSameBackground(cardFunction.background_image, img)
  );

  const applyPresetBackgroundChange = (img) => {
    if (isTeamOwnerInTeamMode) updateTeamBackgroundRef.current = true;
    brandingOverridesRef.current.background_image = true;
    setCardFunction((prev) => ({ ...prev, background_image: img }));
  };

  const handlePresetBackgroundChange = (img) => {
    if (isBrandingLocked || customBackgroundImage) return;
    if (
      isTeamOwnerInTeamMode &&
      !isSameBackground(cardFunction.background_image, img)
    ) {
      setPendingTeamBackgroundChange({ type: "preset", img });
      return;
    }
    applyPresetBackgroundChange(img);
  };

  const handleTeamBackgroundUploadOpen = () => {
    if (isBrandingLocked) return;
    if (
      isTeamOwnerInTeamMode
    ) {
      setPendingTeamBackgroundChange({ type: "upload" });
      return;
    }
    teamBackgroundUploadConfirmedRef.current = isTeamOwnerInTeamMode;
    handleUploadImageOpen("background_image");
  };

  const proceedTeamBackgroundChange = () => {
    if (pendingTeamBackgroundChange?.type === "preset") {
      applyPresetBackgroundChange(pendingTeamBackgroundChange.img);
    } else if (pendingTeamBackgroundChange?.type === "upload") {
      teamBackgroundUploadConfirmedRef.current = true;
      handleUploadImageOpen("background_image");
    }
    setPendingTeamBackgroundChange(null);
  };

  const applyCardColorChange = (color, isCustom = false) => {
    if (isTeamOwnerInTeamMode) updateTeamColorRef.current = true;
    brandingOverridesRef.current.color = true;
    setCardFunction((prev) => ({ ...prev, color }));
    setCustomColor(isCustom);
  };

  const handlePresetCardColorChange = (color) => {
    if (isBrandingLocked) return;
    if (
      isTeamOwnerInTeamMode &&
      cardFunction.color?.toLowerCase() !== color.toLowerCase()
    ) {
      setPendingTeamColorChange({ color, isCustom: false });
      return;
    }
    applyCardColorChange(color);
  };

  const handleCustomCardColorChange = (color) => {
    if (
      isTeamOwnerInTeamMode &&
      cardFunction.color?.toLowerCase() !== color.toLowerCase()
    ) {
      setPendingTeamColorChange({ color, isCustom: true });
      handleColorPickerClose();
      return;
    }
    applyCardColorChange(color, true);
  };

  const proceedTeamColorChange = () => {
    if (pendingTeamColorChange) {
      applyCardColorChange(
        pendingTeamColorChange.color,
        pendingTeamColorChange.isCustom
      );
    }
    setPendingTeamColorChange(null);
  };

  const handleTeamLogoUploadOpen = () => {
    if (isBrandingLocked) return;
    if (isTeamOwnerInTeamMode) {
      setPendingTeamLogoChange(true);
      return;
    }
    handleUploadImageOpen("logo");
  };

  const proceedTeamLogoChange = () => {
    teamLogoUploadConfirmedRef.current = true;
    setPendingTeamLogoChange(false);
    handleUploadImageOpen("logo");
  };

  const [customPronoun, setCustomPronoun] = useState("");
  const [pronounCheckBox, setPronounCheckBox] = useState(false);
  const [showSkipButton, setShowSkipButton] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [selectedLogoShape, setSelectedLogoShape] = useState(null);
  const [selectedView, setSelectedView] = useState(null);

  const [customLabel, setCustomLabel] = useState([
    {
      index_no: "",
      label: "",
    },
  ]);

  const [customMediaLink, setCustomMediaLink] = useState("");
  const [customMediaLinkError, setCustomMediaLinkError] = useState({});
  const { compareLimits, updateCount } = useFunctionsCount();
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);

  const navigate = useNavigate();
  const { teamId, userId } = useParams();


  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");

  // Pre-fill team branding: team owner in team mode, or any team member
  useEffect(() => {
    if (shouldApplyTeamBranding && teamBranding) {
      setCardFunction((prev) => ({
        ...prev,
        // Branding supplies defaults only. Never replace a value already
        // selected in this card wizard if branding data refreshes later.
        background_image: isBrandingLocked
          ? teamBranding.card_background_image || prev.background_image
          : prev.background_image || teamBranding.card_background_image,
        color: isBrandingLocked
          ? teamBranding.card_color || prev.color
          : prev.color || teamBranding.card_color,
        logo: isBrandingLocked
          ? teamBranding.logo || prev.logo
          : prev.logo || teamBranding.logo,
        logo_shape: isBrandingLocked
          ? teamBranding.card_logo_shape || prev.logo_shape
          : prev.logo_shape || teamBranding.card_logo_shape,
      }));
      if (teamBranding.card_logo_shape) {
        setLogoImageShape(teamBranding.card_logo_shape);
        setSelectedLogoShape(teamBranding.card_logo_shape);
      }
      // If the team card_color is not a preset swatch, mark it as a custom color
      // so the custom color tile shows it as pre-selected
      if (isTeamOwnerInTeamMode && teamBranding.card_color) {
        const isPreset = Colors.some((c) => c.bgColor === teamBranding.card_color);
        if (!isPreset) setCustomColor(true);
      }
    }
  }, [
    shouldApplyTeamBranding,
    teamBranding?.card_background_image,
    teamBranding?.card_color,
    teamBranding?.logo,
    teamBranding?.card_logo_shape,
    isTeamOwnerInTeamMode,
    isBrandingLocked,
  ]);

  const handleCloseModal = () => {
    setCrop();
    setShowModal(false);
  };

  useEffect(() => {
    if (result) {
      if (cropType == "profile") {
        setCardFunction({ ...cardFunction, profile_image: fileData });
      } else {
        setCardFunction({ ...cardFunction, logo: fileData });
      }

      setCropType("");
    }
  }, [result]);

  const handleCustomPronounChange = (e) => {
    setCustomPronoun(e.target.value);
  };

  // handle phone type input change
  const handlePhoneTypeChange = (e, index) => {
    const type = e.target.value;
    if (
      e.target.value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    const newArray = cardFunction.card_phone.map((item, i) => {
      if (index === i) {
        // return { ...item, phone_type: e.target.value };
        return {
          ...item,
          phone_type: type,
          // Clear extension if not work
          phone_extension: type === "work" ? item.phone_extension || "" : "",
        };
      } else {
        return item;
      }
    });
    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  // handle phone type input change
  const handlePhoneNumberChange = (value, country, index) => {
    const newArray = cardFunction.card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          phone_number: value,
          country_phone: `${country.dialCode}`,
        };
      } else {
        return item;
      }
    });
    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  const handleCustomLabel = (e, index) => {
    const newArray = cardFunction.card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          custom_label: e.target.value,
        };
      } else {
        return item;
      }
    });
    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  const handlePhoneExtensionChange = (e, index) => {
    const newArray = cardFunction.card_phone.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          phone_extension: e.target.value,
        };
      }
      return item;
    });

    setCardFunction({ ...cardFunction, card_phone: newArray });
  };

  const addPhoneFormField = () => {
    setCardFunction({
      ...cardFunction,
      card_phone: [
        ...cardFunction.card_phone,
        {
          phone_type: "",
          country_phone: "",
          phone_number: "",
          custom_label: "",
          phone_extension: "",
        },
      ],
    });
  };

  const removePhoneFormField = (i) => {
    let removeCardPhone = [...cardFunction.card_phone];
    removeCardPhone.splice(i, 1);
    setCardFunction({ ...cardFunction, card_phone: removeCardPhone });
    setErrors({});
  };

  // const filteredMediaLinks = useMemo(() => {
  //   const filteredLinks = _.cloneDeep(AddMoreCustomUrls);
  //   const newFilteredLinks = [];
  //   filteredLinks.forEach((item) => {
  //     const found = modalMediaLinks.find(
  //       (single) => single.media_type === item.name
  //     );

  //     if (!found || item.name === "custom") {
  //       newFilteredLinks.push(item);
  //     }
  //   });

  //   return newFilteredLinks;
  // }, [modalMediaLinks]);

  const filteredMediaLinks = useMemo(() => {
    const filteredLinks = _.cloneDeep(AddMoreCustomUrls);
    if (purchasedPackage.id === 1) {
      const newFilteredLinks = [];
      filteredLinks.forEach((item) => {
        const found = modalMediaLinks.find(
          (single) => single.media_type === item.name
        );
        if (!found || item.name === "custom") {
          newFilteredLinks.push(item);
        }
      });
      return newFilteredLinks;
    } else {
      return filteredLinks;
    }
  }, [modalMediaLinks]);

  const handleImageChange = (files) => {
    const selectedFile = files[0];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB

    if (selectedFile.size > maxSizeInBytes) {
      showToast(
        false,
        "The selected image size exceeds the maximum limit of 10MB."
      );
      return;
    }

    setCardFunction({ ...cardFunction, [imageUploadKey]: selectedFile });

    if (imageUploadKey === "profile_image") {
      setPreview(URL.createObjectURL(selectedFile));
      setShowModal(true);
      setCropType("profile");
    }
    if (imageUploadKey === "logo") {
      brandingOverridesRef.current.logo = true;
      if (teamLogoUploadConfirmedRef.current) {
        updateTeamLogoRef.current = true;
        teamLogoUploadConfirmedRef.current = false;
      }
      setPreview(URL.createObjectURL(selectedFile));
      setShowModal(true);
      setCropType("logo");
    }
    if (imageUploadKey === "background_image") {
      brandingOverridesRef.current.background_image = true;
      if (teamBackgroundUploadConfirmedRef.current) {
        updateTeamBackgroundRef.current = true;
        teamBackgroundUploadConfirmedRef.current = false;
      }
      setCustomBackgroundImage(true);
    }

    handleUploadImageClose();
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: handleImageChange,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
  });

  const handleMediaOpen = () => {
    setModalMediaLinks(_.cloneDeep(cardFunction.card_social_media));
    setMediaOpen(true);
  };

  const handleMediaClose = () => {
    setModalMediaLinks([]);
    setMediaLinkErrors({});
    setMediaOpen(false);
  };

  const handleColorPickerOpen = () => setColorPickerOpen(true);
  const handleColorPickerClose = () => setColorPickerOpen(false);

  const handleUploadImageOpen = (key) => {
    if (
      key === "background_image" &&
      !isTeamOwner &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }
    setUploadImageOpen(true);
    setImageUploadKey(key);
  };

  const handleUploadImageClose = () => {
    setUploadImageOpen(false);
    setImageUploadKey("");
  };

  const handleSkip = () => {
    setErrors({});
    // Fallback color: team branding color (if in team mode) or first preset
    const fallbackColor = teamBranding?.card_color || Colors[0].bgColor;

    if (cardFunction.card_type === "personal") {
      if (tabValue === 2) {
        setCardFunction({
          ...cardFunction,
          background_image: CardBackGroundImages[0].img,
        });
      }

      if (tabValue === 3) {
        setCardFunction({
          ...cardFunction,
          profile_image: "",
        });
      }

      if (tabValue === 4) {
        setCardFunction({ ...cardFunction, color: fallbackColor });
      }

      if (tabValue === 5) {
        setCardFunction({
          ...cardFunction,
          description: "",
          address: "",
          city: "",
          state: "",
          country: "",
          website_url: "",
        });
      }

      if (tabValue === 6) {
        setCardFunction({
          ...cardFunction,
          card_phone: [],
        });
      }
    }

    if (cardFunction.card_type === "business") {
      if (tabValue === 2) {
        setCardFunction({
          ...cardFunction,
          company: "",
          company_position: "",
        });
      }

      if (tabValue === 3) {
        // Keep team background for team owner in team mode, else reset to first preset
        setCardFunction({
          ...cardFunction,
          background_image: teamBranding?.card_background_image || CardBackGroundImages[0].img,
        });
      }

      if (tabValue === 4) {
        setCardFunction({
          ...cardFunction,
          profile_image: "",
        });
      }

      if (tabValue === 5) {
        // Keep team logo for team owner in team mode, else clear
        setCardFunction({
          ...cardFunction,
          logo: teamBranding?.logo || "",
        });
      }

      if (tabValue === 6) {
        setCardFunction({ ...cardFunction, color: fallbackColor });
      }

      if (tabValue === 7) {
        setCardFunction({
          ...cardFunction,
          description: "",
          address: "",
          city: "",
          state: "",
          country: "",
          website_url: "",
        });
      }

      if (tabValue === 8) {
        setCardFunction({
          ...cardFunction,
          card_phone: [],
        });
      }
    }

    // Skip the background tab when team members use Skip
    const nextSkipTab = (() => {
      let t = tabValue + 1;
      if (hideBackground) {
        if (cardFunction.card_type === "business" && t === 3) t++;
        if (cardFunction.card_type === "personal" && t === 2) t++;
      }
      return t;
    })();
    handleShowSkip(nextSkipTab);
    setTabValue(nextSkipTab);
  };

  const handleTabIncrement = () => {
    if (tabValue === 0) {
      if (!validateForm(tab0Schema)) return;
    }

    if (tabValue === 1) {
      if (cardFunction.pronouns === "custom" && customPronoun.length > 20) {
        setErrors({
          custom_pronouns: "Custom pronouns can be max 20 characters long",
        });
        return;
      }

      if (!validateForm(tab1Schema)) return;
    }

    if (
      (cardFunction.card_type === "business" && tabValue === 7) ||
      (cardFunction.card_type === "personal" && tabValue === 5)
    ) {
      if (!validateForm(moreDetailSchema)) return;
    }

    if (
      (cardFunction.card_type === "business" && tabValue === 8) ||
      (cardFunction.card_type === "personal" && tabValue === 6)
    ) {
      setErrors({});
      for (let index = 0; index < cardFunction.card_phone.length; index++) {
        const data = cardFunction.card_phone[index];
        if (data.phone_type || data.phone_number) {
          if (data.phone_type === "") {
            setErrors({
              [`phone_number${index}`]: "Please select phone type",
            });
            return;
          }

          if (data.phone_number === "") {
            setErrors({
              [`phone_number${index}`]: "Please enter phone number",
            });
            return;
          }

          if (data.phone_number.length > data.country_phone.length) {
            let resultPhone = validatePhoneWithCountryCode(
              data.country_phone,
              data.phone_number
            );
            if (resultPhone) {
              setErrors({
                [`phone_number${index}`]: resultPhone,
              });
              return false;
            }
          }

          if (data.phone_type === "custom" && data.custom_label === "") {
            setErrors({
              [`lable${index}`]: "Please enter custom phone label",
            });
            return;
          }
          if (data.phone_type === "custom" && data.custom_label.length > 20) {
            setErrors({
              [`lable${index}`]: "Custom Label can be max 20 characters long",
            });
            return;
          }
        }
      }

      let filterNumbers = cardFunction.card_phone.filter(function (el) {
        return el.phone_number != "";
      });

      setCardFunction({
        ...cardFunction,
        card_phone: filterNumbers,
      });
    }

    if (cardFunction.card_type === "business" && tabValue === 2) {
      if (!validateForm(companyInfoSchema)) return;
    }

    // Skip the background tab when team members navigate forward
    const nextTab = (() => {
      let t = tabValue + 1;
      if (hideBackground) {
        if (cardFunction.card_type === "business" && t === 3) t++;
        if (cardFunction.card_type === "personal" && t === 2) t++;
      }
      return t;
    })();

    if (cardFunction.card_type === "business") {
      setTabHeader(businessHeaderValues[nextTab]);
    } else {
      setTabHeader(personalHeaderValues[nextTab]);
    }

    if (cardFunction.card_type === "business") {
      if (nextTab === 3 && !hideBackground) {
        if (!cardFunction.background_image) {
          setCardFunction({
            ...cardFunction,
            background_image: CardBackGroundImages[0].img,
          });
        }
      } else if (nextTab === 6) {
        const resolvedColor = cardFunction.color || teamBranding?.card_color || Colors[0].bgColor;
        if (!cardFunction.color) {
          setCardFunction({ ...cardFunction, color: resolvedColor });
        }
        if (isTeamOwnerInTeamMode && resolvedColor && !Colors.some((c) => c.bgColor === resolvedColor)) {
          setCustomColor(true);
        }
      }
    } else {
      if (nextTab === 2 && !hideBackground) {
        if (!cardFunction.background_image) {
          setCardFunction({
            ...cardFunction,
            background_image: CardBackGroundImages[0].img,
          });
        }
      } else if (nextTab === 4) {
        const resolvedColor = cardFunction.color || teamBranding?.card_color || Colors[0].bgColor;
        if (!cardFunction.color) {
          setCardFunction({ ...cardFunction, color: resolvedColor });
        }
        if (isTeamOwnerInTeamMode && resolvedColor && !Colors.some((c) => c.bgColor === resolvedColor)) {
          setCustomColor(true);
        }
      } else if (nextTab === 9) {
        const resolvedColor = cardFunction.color || teamBranding?.card_color || Colors[0].bgColor;
        if (!cardFunction.color) {
          setCardFunction({ ...cardFunction, color: resolvedColor });
        }
        if (isTeamOwnerInTeamMode && resolvedColor && !Colors.some((c) => c.bgColor === resolvedColor)) {
          setCustomColor(true);
        }
      }
    }

    handleShowSkip(nextTab);
    setTabValue(nextTab);
  };

  const handleTabDecrement = () => {
    // Skip the background tab when team members navigate backward
    let prevTab = tabValue - 1;
    if (hideBackground) {
      if (cardFunction.card_type === "business" && prevTab === 3) prevTab--;
      if (cardFunction.card_type === "personal" && prevTab === 2) prevTab--;
    }
    handleShowSkip(prevTab);
    setTabValue(prevTab);
    if (cardFunction.card_type === "business") {
      setTabHeader(businessHeaderValues[prevTab]);
    } else {
      setTabHeader(personalHeaderValues[prevTab]);
    }
  };

  const handleShowSkip = (value) => {
    // check on the base of businese or personal
    if (cardFunction.card_type === "business") {
      if ([0, 1, 10, 11].includes(value)) {
        setShowSkipButton(false);
      } else {
        setShowSkipButton(true);
      }
    } else {
      if ([0, 1, 8, 9].includes(value)) {
        setShowSkipButton(false);
      } else {
        setShowSkipButton(true);
      }
    }
  };

  const handleChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;

    // Validation for first_name & last_name
    if (name === "first_name" || name === "last_name") {
      const hasNumber = /\d/.test(value); // check if numbers exist
      if (hasNumber) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Numbers are not allowed in this field",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    if (
      name === "pronouns" &&
      value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      setCardFunction({ ...cardFunction, pronouns: "" });
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    setCardFunction({ ...cardFunction, [name]: value });
    if (name === "card_type") {
      if (value === "business") {
        setTotalTabCount(11);
      } else {
        setTotalTabCount(9);
      }
    }
  };

  const handleMediaChange = (e) => {
    if (
      e.target.value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      setCardFunction({ ...cardFunction, pronouns: "" });
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    if (e.target.value === "custom") {
      setMediaOpen(false);
      setCustomMediaLinkOpen(true);
    }

    const found = AddMoreCustomUrls.find(
      (item) => item.name === e.target.value
    );

    if (found) {
      let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

      newSocialMediaLinks.push({
        media_type: found.name,
        url: e.target.link ? e.target.link : "",
        icon: found.name === "custom" ? "custom" : found.icon,
        custom_label: "",
      });

      setModalMediaLinks(newSocialMediaLinks);
    }
  };

  const handleCustomMediaNameSave = () => {
    if (!validateCustomMediaLink()) return;

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks[newSocialMediaLinks.length - 1].custom_label =
      customMediaLink;

    setModalMediaLinks(newSocialMediaLinks);
    setCustomMediaLinkOpen(false);
    setCustomMediaLink("");
    setMediaOpen(true);
  };

  const handleCustomMediaModalClose = () => {
    setCustomMediaLinkOpen(false);

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);
    newSocialMediaLinks.splice(newSocialMediaLinks.length - 1, 1);
    setModalMediaLinks(newSocialMediaLinks);

    setMediaOpen(true);
  };

  const handleModalUrlChange = (e, index) => {
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks[index].url = formatUrl(e.target.value);
    setModalMediaLinks(newSocialMediaLinks);
  };

  const handleMedialSave = () => {
    if (!validateMediaModalForm()) return;

    setCardFunction({ ...cardFunction, card_social_media: modalMediaLinks });
    handleMediaClose();
  };

  const handleMediaDelete = (index) => {
    let newSocialMediaLinks = _.cloneDeep(cardFunction.card_social_media);
    newSocialMediaLinks.splice(index, 1);
    setCardFunction({
      ...cardFunction,
      card_social_media: newSocialMediaLinks,
    });
  };

  const handleModalMediaDelete = (index) => {
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);
    newSocialMediaLinks.splice(index, 1);
    setModalMediaLinks(newSocialMediaLinks);
  };

  const validateForm = (schema) => {
    let newErrors = ValidateSchema(cardFunction, schema);

    setErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const validateMediaModalForm = () => {
    let newErrors = ValidateSchema(modalMediaLinks, socialMediaLinksSchema);

    setMediaLinkErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const validateCustomMediaLink = () => {
    let newErrors = ValidateSchema(
      { customMediaLink },
      Joi.object({
        customMediaLink: Joi.string().max(50).required().messages({
          "string.empty": `Please enter Custom Media Name`,
          "string.max": `Custom Media Name must be maximum 50 characters!`,
        }),
      })
    );

    setCustomMediaLinkError(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const validatePhoneNumber = () => {
    let newErrors = ValidateSchema(cardFunction.card_phone, phoneNumberSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };
  const search = location.search;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);

    let payload = _.cloneDeep(cardFunction);
    const isImageFile = (value) =>
      (typeof File !== "undefined" && value instanceof File) ||
      (typeof Blob !== "undefined" && value instanceof Blob);
    const isNew = !cardFunction?.id;
    console.log("cardFunction.id:", cardFunction?.id, "isNew:", isNew);

    // Re-apply locked team branding for members so submitted values cannot
    // drift from Settings. Owners can override the pre-filled values per card.
    if (isBrandingLocked && teamBranding) {
      payload.background_image =
        teamBranding.card_background_image || payload.background_image;
      payload.color = teamBranding.card_color || payload.color;
      payload.logo = teamBranding.logo || payload.logo;
    }

    // A team owner's card starts from Team Branding. The final displayed
    // values (branding defaults or per-card choices) are saved on the card so
    // every list, view, edit, and share API returns the same appearance.
    if (isTeamOwnerInTeamMode && teamBranding) {
      payload.background_image =
        payload.background_image || teamBranding.card_background_image;
      payload.color = payload.color || teamBranding.card_color;
      payload.logo = payload.logo || teamBranding.logo;
    }

    payload.content_view_type = cardFunction.content_view_type;
    payload.profile_image_shape = cardFunction.profile_image_shape;
    payload.logo_shape =
      isBrandingLocked && teamBranding?.card_logo_shape
        ? teamBranding.card_logo_shape
        : cardFunction.logo_shape || teamBranding?.card_logo_shape;

    const searchParams = new URLSearchParams(window.location.search);
    const source = dynamicQRCodeId
      ? "QR Code"
      : searchParams.has("team_id") && searchParams.has("user_id")
        ? "Team Function"
        : "Function Page";

    // Handle website Url
    payload.website_url = formatUrl(payload.website_url);
    const profileImageUpload =
      isImageFile(payload.profile_image)
        ? payload.profile_image
        : null;

    if (isImageFile(payload.background_image)) {
      const { status, message, data } = await uploadImage(
        "card_background",
        payload.background_image,
        loggedUser?.token
      );

      if (status) {
        payload.background_image = data;
      } else {
        showToast(status, message);
        setFormLoading(false);
        return;
      }
    }

    if (isImageFile(payload.profile_image)) {
      const { status, message, data } = await uploadImage(
        "card_profile",
        payload.profile_image,
        loggedUser?.token
      );

      if (status) {
        payload.profile_image = data;
      } else {
        showToast(status, message);
        setFormLoading(false);
        return;
      }
    }

    if (isImageFile(payload.logo) && payload.card_type === "business") {
      const { status, message, data } = await uploadImage(
        "card_logo",
        payload.logo,
        loggedUser?.token
      );

      if (status) {
        payload.logo = data;

        // The upload API names card images with a timestamp. When profile and
        // logo uploads land in the same interval it can return the same path,
        // causing the logo file to overwrite the profile file. Re-upload the
        // profile in the next interval so both fields keep distinct images.
        if (profileImageUpload && payload.profile_image === payload.logo) {
          await new Promise((resolve) => setTimeout(resolve, 1100));
          const {
            status: profileRetryStatus,
            message: profileRetryMessage,
            data: profileRetryData,
          } = await uploadImage(
            "card_profile",
            profileImageUpload,
            loggedUser?.token
          );

          if (!profileRetryStatus) {
            showToast(profileRetryStatus, profileRetryMessage);
            setFormLoading(false);
            return;
          }

          payload.profile_image = profileRetryData;
        }
      } else {
        showToast(status, message);
        setFormLoading(false);
        return;
      }
    }

    if (payload.card_type === "personal") {
      payload.logo = "";
    }

    payload.card_social_media.forEach((item) => {
      delete item.icon;
    });

    if (payload.card_phone.length > 0) {
      let cardPhoneArr = payload.card_phone.map((item, index) => {
        if (item.phone_type === "custom") {
          return {
            ...item,
            phone_type: item.custom_label ? item.custom_label : "custom",
            phone_number: item.phone_number.slice(
              item.country_phone.length,
              item.phone_number.length
            ),
          };
        } else {
          return {
            ...item,
            phone_number: item.phone_number.slice(
              item.country_phone.length,
              item.phone_number.length
            ),
          };
        }
      });

      cardPhoneArr.forEach((object) => {
        delete object["custom_label"];
      });

      payload.card_phone = cardPhoneArr;
    }

    if (payload.pronouns === "custom") {
      payload.pronouns = customPronoun;
    }

    if (payload.pronouns === "custom" && customPronoun === "") {
      payload.pronouns = "";
    }

    if (teamId && userId) {
      payload.team_id = teamId;
      payload.user_id = userId;
    }
    if (team_id && user_id) {
      payload.team_id = team_id;
      payload.user_id = user_id;
    }
    if (userTeamId) {
      payload.team_id = userTeamId;
    }
    if (dynamicQRCodeId !== null) {
      payload.dynamic_qr_code_id = dynamicQRCodeId;
    }

    let { status, message, data } = await post(
      Card_URL,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      if (isTeamOwnerInTeamMode && data?.id) {
        saveCardBrandingOverride(data.id, data.uuid, {
          ...(brandingOverridesRef.current.background_image
            ? { background_image: payload.background_image }
            : {}),
          ...(brandingOverridesRef.current.color
            ? { color: payload.color }
            : {}),
          ...(brandingOverridesRef.current.logo
            ? { logo: payload.logo }
            : {}),
        });
      }
      handleTabIncrement();
      updateCount(functionTypes.CARD, functionTypes.ADD, dynamicQRCodeId);

      trackEvent(
        isNew ? `Card Added from ${source}` : `Card Updated from ${source}`,
        {
          source,
          isNew,
          card_type: payload.card_type,
          team_id: payload.team_id,
          user_id: payload.user_id,
          dynamic_qr_code_id: payload.dynamic_qr_code_id || null,
          card_id: data?.id || null,
          payload: {
            ...payload,
          },
        }
      );
      setTimeout(() => {
        if (dynamicQRCodeId) {
          if (teamId && userId) {
            navigate(`/function/cards?dynamic_qr_code=${dynamicQRCodeId}`);
          } else {
            navigate(
              `/function/cards?dynamic_qr_code=${dynamicQRCodeId}${team_id && user_id
                ? `?team_id=${team_id}&user_id=${user_id}`
                : ""
              }`
            );
          }
        } else if (teamId && userId) {
          navigate(-1);
        } else {
          navigate(
            `/function/cards${team_id && user_id ? `?team_id=${team_id}&user_id=${user_id}` : ""
            }`
          );
        }
      }, 2000);
    }
    showToast(status, message);

    setFormLoading(false);
  };

  const handleShowSidebar = () => {
    let cardView = document.querySelector(".cardView");
    cardView.classList.add("showCardView");
  };

  const handleHideCardView = () => {
    let cardView = document.querySelector(".cardView");
    cardView.classList.remove("showCardView");
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  const [socialListOpen, setSocialListOpen] = useState(false);

  useEffect(() => {
    const handler = () => setSocialListOpen(false);

    window.addEventListener("click", handler);

    return () => {
      window.removeEventListener("click", handler);
    };
  });

  const handleClick = (e) => {
    e.stopPropagation();

    if (!disabled) {
      setSocialListOpen(!socialListOpen);
    }
  };
  const [inputValue, setInputValue] = useState("");
  const instagramRef = useRef();
  const facebookRef = useRef();
  const twitterRef = useRef();

  const createSocialMediaButton = (platform) => (
    <p
      onClick={() =>
        handleMediaChange({
          target: { value: platform, link: "" },
        })
      }
    >
      {platform}
    </p>
  );

  const renderSwitch = (param) => {
    switch (param) {
      case "Facebook":
        return (
          <LoginSocialFacebook
            ref={facebookRef}
            //appId={"292102873859116"}
            //appId={"1263530301266635"}
            appId={"956908413125623"}
            fieldsProfile={"link"}
            onResolve={({ provider, data }) => {
              setInputValue(data?.link);
              handleMediaChange({
                target: { value: "Facebook", link: data?.link },
              });
            }}
            onReject={(err) => {
              console.log(err);
            }}
          >
            Facebook
          </LoginSocialFacebook>
        );
      case "instagram":
        return (
          <LoginSocialInstagram
            ref={instagramRef}
            client_id={"375734205323738"}
            client_secret={"f1ee2d7c7b8cc0d60abf863b1f28bd6f"}
            onResolve={({ provider, data }) => {
              handleMediaChange({
                target: { value: "Instagram", link: data?.link },
              });
            }}
            onReject={(err) => {
              console.log(err);
            }}
          >
            Instagram
          </LoginSocialInstagram>
        );
      // case "google":
      //   return (
      //     // <LoginSocialGoogle
      //     //   client_id={
      //     //     "37788172788-akfnf1uot3c2ebnbmqqali7ruhl9278a.apps.googleusercontent.com"
      //     //   }
      //     //   scope="openid profile email"
      //     //   discoveryDocs="claims_supported"
      //     //   access_type="offline"
      //     //   onResolve={({ provider, data }) => {
      //     //     const sdgvsfrbgh = data?.userinfo?.email;
      //     //     setInputValue(data);
      //     //   }}
      //     //   onReject={(err) => {
      //     //     console.log("err", err);
      //     //   }}
      //     // >
      //     //   google
      //     // </LoginSocialGoogle>

      //     <p
      //       onClick={() =>
      //         handleMediaChange({ target: { value: "google", link: "" } })
      //       }
      //     >
      //       Google
      //     </p>
      //   );
      case "Google":
        return createSocialMediaButton("Google");
      case "Youtube":
        return createSocialMediaButton("Youtube");
      case "Spotify":
        return createSocialMediaButton("Spotify");
      case "Vimeo":
        return createSocialMediaButton("Vimeo");
      case "Twitter":
        return createSocialMediaButton("Twitter");
      case "Dribble":
        return createSocialMediaButton("Dribble");
      case "SoundCloud":
        return createSocialMediaButton("SoundCloud");
      case "Pinterest":
        return createSocialMediaButton("Pinterest");
      case "Android":
        return createSocialMediaButton("Android");
      case "LinkedIn":
        return createSocialMediaButton("LinkedIn");
      case "SnapChat":
        return createSocialMediaButton("SnapChat");
      case "Behance":
        return createSocialMediaButton("Behance");
      case "Tumblr":
        return createSocialMediaButton("Tumblr");
      case "Messenger":
        return createSocialMediaButton("Messenger");
      case "Whatsapp":
        return createSocialMediaButton("Whatsapp");
      case "Skype":
        return createSocialMediaButton("Skype");
      case "Dropbox":
        return createSocialMediaButton("Dropbox");
      case "Wordpress":
        return createSocialMediaButton("Wordpress");
      case "Tiktok":
        return createSocialMediaButton("Tiktok");
      default:
        return "custom";
    }
  };

  return (
    <>
      {!loading ? (
        <div className="row">
          <div className="col-md-8 col-12">
            {/* <div className="row">
              <div className="d-flex align-items-center justify-content-between">
                <h6 className="title">
                  <Link
                    onClick={handleGoBack}
                    style={{ color: "var(--heading_text_color)" }}
                  >
                    Functions
                  </Link>
                  {" > Cards"}
                </h6>
                <div className="view">
                  <button onClick={handleShowSidebar}>View Card</button>
                </div>
              </div>
            </div> */}
            <div className="row align-items-center mb-4">
              <div className="col-6">
                <div className="heading">
                  <h1 className="mb-0">
                    <Link to="/" className="function-link">
                      Functions
                    </Link>
                    {` > Cards`}
                  </h1>
                  {/* <div className="view">
                    <button onClick={handleShowSidebar}>View Card</button>
                  </div> */}
                </div>
              </div>
              {/* <div className="col-6 text-end">
                <Button variant="primary" onClick={handleNewCard}>
                  <MdAddBox /> New Digital Card
                </Button>
              </div> */}
            </div>

            <div className="mainWrapper-inputcard card step-card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <Button
                      variant="outline-primary"
                      onClick={handleTabDecrement}
                      className="prevBtn me-3"
                      disabled={
                        tabValue === 0 ||
                        (cardFunction.card_type === "business"
                          ? tabValue === 11
                          : tabValue === 9)
                      }
                    >
                      <FiChevronLeft /> Back
                    </Button>

                    <Button
                      variant="outline-primary"
                      onClick={handleTabIncrement}
                      className="nextBtn"
                      disabled={
                        cardFunction.card_type === "business"
                          ? tabValue === 10 || tabValue === 11
                            ? true
                            : false
                          : tabValue === 8 || tabValue === 9
                            ? true
                            : false
                      }
                    >
                      Next <FiChevronRight />
                    </Button>
                  </div>
                  <div>
                    {(
                      cardFunction.card_type === "business"
                        ? tabValue === 10
                        : tabValue === 8
                    ) ? (
                      <Button
                        className="skipButton"
                        onClick={handleSubmit}
                        disabled={formLoading}
                      >
                        {formLoading ? "Saving..." : "Save"}
                      </Button>
                    ) : (
                      // <div style={tabValue !== 0 ? { width: "55px" } : null}>
                      showSkipButton && (
                        <Button className="skipButton" onClick={handleSkip}>
                          skip
                        </Button>
                      )
                      // </div>
                    )}
                  </div>
                </div>
                <div className="cardFormWrapper">
                  {formLoading ? (
                    <div className="loaderWrapper">
                      <div className={loaderClasses.loader} />
                    </div>
                  ) : (
                    <>
                      <div className="cardHeaderWrapper">
                        {/* {tabValue !== 0 ? (
                          <span className="tabCount">
                            <span>{tabValue}</span> / {totalTabCount}
                          </span>
                        ) : (
                          <div />
                        )} */}

                        <div
                          className="tabHeader"
                          dangerouslySetInnerHTML={{ __html: tabHeader }}
                        />
                      </div>

                      <div style={tabValue === 0 ? null : { display: "none" }}>
                        {/* <img src={cardtype} alt="" className="formImage" /> */}
                        <div className="form-group custom-select mt-3">
                          <Select
                            placeholder="Choose your card type"
                            options={options}
                            value={cardFunction.card_type}
                            name="card_type"
                            onChange={handleChange}
                          />
                          <span className="errorText">{errors.card_type}</span>
                        </div>
                      </div>

                      <div style={tabValue === 1 ? null : { display: "none" }}>
                        <div className="cardBodyWrapper">
                          {/* <div className="text-center">
                            <img src={cardname} alt="" className="formImage" />
                          </div> */}
                          <div className="selectWrapper">
                            {/* <div
                              className="moreDetailHeader"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <BsFillPersonFill />
                                <span>Pronouns</span>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  name="pronoun_check"
                                  checked={pronounCheckBox}
                                  onChange={(e) => {
                                    setPronounCheckBox(e.target.checked);

                                    if (!e.target.checked) {
                                      setCardFunction({
                                        ...cardFunction,
                                        pronouns: "",
                                      });
                                      setCustomPronoun("");
                                    }
                                  }}
                                />
                              </div>
                            </div> */}

                            <div className="form-group custom-select">
                              <Select
                                placeholder="Choose your pronouns"
                                options={pronounsOptions}
                                value={cardFunction.pronouns}
                                name="pronouns"
                                // disabled={!pronounCheckBox}
                                onChange={handleChange}
                              />
                            </div>
                            {cardFunction.pronouns === "custom" && (
                              <>
                                <div
                                  className={
                                    errors.custom_pronouns
                                      ? "input-group globalInputWithIcon errorInput"
                                      : "input-group  globalInputWithIcon"
                                  }
                                  style={{
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <input
                                    placeholder="Please Enter Custom Pronoun"
                                    className={
                                      errors.custom_pronouns
                                        ? "form-control inputError"
                                        : "form-control"
                                    }
                                    value={customPronoun}
                                    onChange={handleCustomPronounChange}
                                  />
                                </div>
                                <p className="errorText">
                                  {errors.custom_pronouns || ""}
                                </p>
                              </>
                            )}
                          </div>

                          <div className="smallInputWrapper">
                            {/* <label className="inputLabel">First Name</label> */}
                            <FormInput
                              type="text"
                              name="first_name"
                              placeholder="First name"
                              value={cardFunction.first_name}
                              handleChange={handleChange}
                              error={errors.first_name}
                            />
                          </div>
                          <div className="smallInputWrapper">
                            {/* <label className="inputLabel">Last Name</label> */}
                            <FormInput
                              type="text"
                              name="last_name"
                              placeholder="Last name"
                              value={cardFunction.last_name}
                              handleChange={handleChange}
                              error={errors.last_name}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        style={
                          tabValue === 2 &&
                            cardFunction.card_type === "business"
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="cardBodyWrapper">
                          {/* <div className="text-center">
                            <img src={company} alt="" className="formImage" />
                          </div> */}

                          <div className="smallInputWrapper">
                            {/* <label className="inputLabel">Company Name</label> */}
                            <FormInput
                              type="text"
                              name="company"
                              placeholder="Company Name"
                              value={cardFunction.company}
                              handleChange={handleChange}
                              error={errors.company}
                            />
                          </div>

                          <div className="smallInputWrapper">
                            {/* <label className="inputLabel">Job Position</label> */}
                            <FormInput
                              type="text"
                              name="company_position"
                              placeholder="Job Position"
                              value={cardFunction.company_position}
                              handleChange={handleChange}
                              error={errors.company_position}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 3
                              : tabValue === 2
                          ) && !hideBackground
                            ? null
                            : { display: "none" }
                        }
                      >
                        {pendingTeamBackgroundChange && (
                          <div
                            className="alert alert-warning d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4"
                            role="alert"
                          >
                            <div>
                              <strong>Use a different background for this card?</strong>
                              <div className="mt-1">
                                This background will apply only to this card.
                                Team Branding and all other team or personal
                                cards will not be changed.
                              </div>
                            </div>
                            <div className="d-flex gap-2 flex-shrink-0">
                              <Button
                                variant="outline-secondary"
                                type="button"
                                onClick={() =>
                                  setPendingTeamBackgroundChange(null)
                                }
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="warning"
                                type="button"
                                onClick={proceedTeamBackgroundChange}
                              >
                                Proceed
                              </Button>
                            </div>
                          </div>
                        )}

                        {/* Preset backgrounds + custom upload — shown for all allowed modes */}
                        <div
                          className="row bacckgroundImageWrapper"
                          style={
                            isBrandingLocked
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          {CardBackGroundImages.map((image) => {
                            const { id, img } = { ...image };
                            return (
                              <div className="col-lg-1" key={`backgroundImage${id}`}>
                                <img
                                  src={`${baseURL.PUBLIC_URL}${img}`}
                                  alt=""
                                  className={`img-fluid ${
                                    isSameBackground(
                                      pendingTeamBackgroundChange?.img,
                                      img
                                    )
                                      ? "pendingBackgroundOption"
                                      : isSameBackground(
                                            cardFunction.background_image,
                                            img
                                          )
                                        ? "selectedOption"
                                        : ""
                                  }`}
                                  onClick={() => handlePresetBackgroundChange(img)}
                                />
                              </div>
                            );
                          })}

                          {/* A custom branding image is not part of the preset
                              list, so show the persisted image as the selected,
                              read-only option for team members. */}
                          {shouldApplyTeamBranding &&
                            cardFunction.background_image &&
                            typeof cardFunction.background_image === "string" &&
                            !selectedBackgroundIsPreset && (
                              <div className="col-lg-1">
                                <img
                                  src={
                                    cardFunction.background_image.startsWith("http") ||
                                    cardFunction.background_image.startsWith("data:")
                                      ? cardFunction.background_image
                                      : `${baseURL.PUBLIC_URL}${cardFunction.background_image}`
                                  }
                                  alt="Selected Team Branding background"
                                  className="img-fluid selectedOption"
                                />
                              </div>
                            )}

                          {/* Custom upload tile — available for a team owner's
                              personal and team cards */}
                          {showCustomBackgroundUpload && (
                            cardFunction.background_image && customBackgroundImage && typeof cardFunction.background_image === "object" ? (
                              <div className="col-lg-1">
                                <div className="customBackgroundWrapper">
                                  <img
                                    src={URL.createObjectURL(cardFunction.background_image)}
                                    alt=""
                                    className="selectedOption"
                                  />
                                  <div className="bgImgClearBtnWrapper">
                                    <MdClose
                                      className="bgImgClearBtn"
                                      onClick={() => {
                                        brandingOverridesRef.current.background_image = false;
                                        setCardFunction({
                                          ...cardFunction,
                                          background_image: teamBranding?.card_background_image || CardBackGroundImages[0].img,
                                        });
                                        setCustomBackgroundImage(false);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="emptyBackgroundImage col-lg-1"
                                onClick={handleTeamBackgroundUploadOpen}
                              >
                                <div>+</div>
                              </div>
                            )
                          )}
                        </div>
                        {isBrandingLocked && (
                          <p className="team-restriction-text mt-3">
                            Card background image is managed by your team owner and can't be edited here.
                          </p>
                        )}

                        {/* <div className="text-center">
                            <button
                              className="uploadBtn"
                              type="button"
                              onClick={() =>
                                handleUploadImageOpen("background_image")
                              }
                            >
                              Upload
                            </button>
                          </div> */}
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 4
                              : tabValue === 3
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="upload-wrapper position-relative">
                          <img
                            src={
                              // result
                              //   ? result :
                              cardFunction.profile_image
                                ? `${URL.createObjectURL(
                                  cardFunction.profile_image
                                )}`
                                : pictureicon
                            }
                            alt=""
                            className="formImage"
                            style={
                              cardFunction.profile_image
                                ? {
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  width: "160px",
                                  height: "160px",
                                }
                                : { width: "160px", height: "160px" }
                            }
                          />

                          <Button
                            variant="outline-primary"
                            className="uploadBtn position-absolute"
                            type="button"
                            onClick={() =>
                              handleUploadImageOpen("profile_image")
                            }
                          >
                            <MdOutlineEdit />
                          </Button>
                        </div>
                        <p className="tabHeader mb-2">
                          Select Profile Image Shape
                        </p>
                        <div className="row gx-3 shape-wrapper">
                          {imgShapeOptions.map((option) => (
                            <div className="col-lg-3" key={option.value}>
                              <div
                                className={`shape-card d-flex align-items-center h-100 ${selectedShape === option.value
                                  ? "highlight-shape"
                                  : ""
                                  }`}
                                onClick={() =>
                                  handleProfileShapeChange(option.value)
                                }
                              >
                                <img
                                  src={option.image}
                                  alt=""
                                  className="viewImage me-3"
                                  onClick={() =>
                                    handleProfileShapeChange(option.value)
                                  }
                                />
                                <p>{option.label}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          tabValue === 5 &&
                            cardFunction.card_type === "business"
                            ? null
                            : { display: "none" }
                        }
                      >
                        {pendingTeamLogoChange && (
                          <div
                            className="alert alert-warning d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4"
                            role="alert"
                          >
                            <div>
                              <strong>Use a different logo for this card?</strong>
                              <div className="mt-1">
                                This logo will apply only to this card. Team
                                Branding and all other team or personal cards
                                will not be changed.
                              </div>
                            </div>
                            <div className="d-flex gap-2 flex-shrink-0">
                              <Button
                                variant="outline-secondary"
                                type="button"
                                onClick={() => setPendingTeamLogoChange(false)}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="warning"
                                type="button"
                                onClick={proceedTeamLogoChange}
                              >
                                Proceed
                              </Button>
                            </div>
                          </div>
                        )}

                        {/* No restriction — default shows team logo, user can override */}
                        <div className="upload-wrapper position-relative">
                          <img
                            src={
                              cardFunction.logo
                                ? (typeof cardFunction.logo === "object"
                                  ? `${URL.createObjectURL(cardFunction.logo)}`
                                  : baseURL.PUBLIC_URL + cardFunction.logo)
                                : companylogo
                            }
                            alt=""
                            className="formImage"
                            style={
                              cardFunction.logo
                                ? { borderRadius: "50%", objectFit: "cover", width: "160px", height: "160px" }
                                : { width: "160px", height: "160px" }
                            }
                          />
                          <Button
                            variant="outline-primary"
                            className="uploadBtn position-absolute"
                            type="button"
                            onClick={handleTeamLogoUploadOpen}
                            disabled={isBrandingLocked}
                            style={
                              isBrandingLocked
                                ? { opacity: 0.5, cursor: "not-allowed" }
                                : {}
                            }
                          >
                            <MdOutlineEdit />
                          </Button>
                        </div>
                        {isBrandingLocked && (
                          <p className="team-restriction-text mt-3">
                            Card logo is managed by your team owner and can't be edited here.
                          </p>
                        )}
                        <p className="tabHeader mb-2">Select Logo Shape</p>
                        <div className="row gx-3 shape-wrapper">
                          {imgShapeOptions.map((option) => (
                            <div className="col-lg-3" key={option.value}>
                              <div
                                className={`shape-card d-flex align-items-center h-100 ${selectedLogoShape === option.value
                                  ? "highlight-shape"
                                  : ""
                                  }`}
                                onClick={() =>
                                  handleLogoShapeChange(option.value)
                                }
                              >
                                <img
                                  src={option.image}
                                  alt=""
                                  className="viewImage me-3"
                                />
                                <p>{option.label}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 6
                              : tabValue === 4
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        {pendingTeamColorChange && (
                          <div
                            className="alert alert-warning d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4"
                            role="alert"
                          >
                            <div>
                              <strong>Use a different color for this card?</strong>
                              <div className="mt-1">
                                This color will apply only to this card. Team
                                Branding and all other team or personal cards
                                will not be changed.
                              </div>
                            </div>
                            <div className="d-flex gap-2 flex-shrink-0">
                              <Button
                                variant="outline-secondary"
                                type="button"
                                onClick={() => setPendingTeamColorChange(null)}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="warning"
                                type="button"
                                onClick={proceedTeamColorChange}
                              >
                                Proceed
                              </Button>
                            </div>
                          </div>
                        )}

                        {/* Preset color swatches + custom color picker */}
                        <div
                          className="d-flex flex-wrap align-items-center gap-2"
                          style={
                            isBrandingLocked
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          {Colors.map((color) => {
                            const { id, bgColor } = { ...color };
                            return (
                              <div
                                key={`color${id}`}
                                style={{ backgroundColor: bgColor }}
                                className={`colorDiv ${
                                  pendingTeamColorChange?.color?.toLowerCase() ===
                                  bgColor.toLowerCase()
                                    ? "pendingColorOption"
                                    : cardFunction.color == bgColor &&
                                        !customColor
                                      ? "selectedColorOption"
                                      : ""
                                }`}
                                onClick={() =>
                                  handlePresetCardColorChange(bgColor)
                                }
                              />
                            );
                          })}
                          {/* Custom colour picker tile — only for team owner in team mode */}
                          {showCustomBackgroundOnly && (
                            <div
                              className="colorDiv d-flex align-items-center justify-content-center"
                              style={{
                                background: pendingTeamColorChange?.isCustom
                                  ? pendingTeamColorChange.color
                                  : customColor
                                    ? cardFunction.color
                                  : "linear-gradient(135deg,#f43,#f80,#ff0,#0f0,#08f,#84f)",
                                cursor: "pointer",
                                fontSize: 11,
                                fontWeight: 600,
                                color: "#fff",
                                textShadow: "0 0 3px rgba(0,0,0,0.6)",
                                border: pendingTeamColorChange?.isCustom
                                  ? "3px solid #ffc107"
                                  : customColor
                                    ? "3px solid var(--blue-color)"
                                    : "2px dashed var(--border_color)",
                              }}
                              onClick={() =>
                                !isBrandingLocked && handleColorPickerOpen()
                              }
                              title="Pick a custom colour"
                            >
                              {customColor ? "✓" : "+"}
                            </div>
                          )}
                        </div>
                        {isBrandingLocked && (
                          <p className="team-restriction-text mt-3">
                            Card color is managed by your team owner and can't be edited here.
                          </p>
                        )}
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 7
                              : tabValue === 5
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="form-group">
                          {/* <div className="moreDetailHeader">
                              <IoDocumentTextSharp />
                              <span>About me</span>
                            </div> */}
                          <textarea
                            // className={classes.textareaInput}
                            className={
                              errors.description
                                ? "globalTextArea errorInput form-control"
                                : "globalTextArea form-control"
                            }
                            type="text"
                            placeholder="About Me"
                            name="description"
                            value={cardFunction.description}
                            onChange={handleChange}
                          ></textarea>
                        </div>

                        <div className="row">
                          {/* <div className="moreDetailHeader">
                              <MdLocationOn />
                              <span>Location</span>
                            </div> */}
                          <div className="col-sm-6">
                            <div className="form-group">
                              <FormInput
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={cardFunction.email}
                                handleChange={handleChange}
                                error={errors.email}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <FormInput
                                type="text"
                                name="website_url"
                                placeholder="Website Url"
                                value={cardFunction.website_url}
                                handleChange={handleChange}
                                error={errors.website_url}
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <FormInput
                              type="text"
                              name="address"
                              placeholder="Address"
                              value={cardFunction.address}
                              handleChange={handleChange}
                              error={errors.address}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              type="text"
                              name="city"
                              placeholder="City"
                              value={cardFunction.city}
                              handleChange={handleChange}
                              error={errors.city}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              type="text"
                              name="state"
                              placeholder="State"
                              value={cardFunction.state}
                              handleChange={handleChange}
                              error={errors.state}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              type="text"
                              name="country"
                              placeholder="Country"
                              value={cardFunction.country}
                              handleChange={handleChange}
                              error={errors.country}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 8
                              : tabValue === 6
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="cardBodyWrapper">
                          {/* <div className="text-center">
                            <img
                              src={contactnumber}
                              alt=""
                              className="formImage"
                            />
                          </div> */}
                          <Button
                            onClick={() => addPhoneFormField()}
                            className="mb-4"
                          >
                            <MdAddBox /> Add Phone
                          </Button>
                          <div className="socialMediaList">
                            {cardFunction &&
                              cardFunction?.card_phone?.map(
                                (element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="phoneInputOuterWrapper"
                                    >
                                      <div className="mb-4">
                                        <div className="d-flex align-items-center">
                                          <div className="d-flex align-items-center">
                                            <div
                                              className={`d-flex align-items-center ${errors[`phone_number${index}`]
                                                ? "phoneInputWrapper errorInput"
                                                : "phoneInputWrapper "
                                                } phoneInputMainWrapper`}
                                            >
                                              <div
                                                className="input-group globalInputWithIcon addCardSelect"
                                                style={{ maxWidth: "100px" }}
                                              >
                                                <select
                                                  className="form-select customSelect"
                                                  onChange={(e) =>
                                                    handlePhoneTypeChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                  value={element.phone_type}
                                                >
                                                  <option value="">
                                                    Select
                                                  </option>
                                                  <option value="home">
                                                    Home
                                                  </option>
                                                  <option value="office">
                                                    Mobile
                                                  </option>
                                                  <option value="work">
                                                    Work
                                                  </option>
                                                  <option value="custom">
                                                    Custom
                                                  </option>
                                                </select>
                                              </div>
                                              <div className="addPhoneInput">
                                                <PhoneInput
                                                  country={"us"}
                                                  enableSearch={true}
                                                  countryCodeEditable={false}
                                                  inputClass={
                                                    errors[
                                                      `phone_number${index}`
                                                    ]
                                                      ? "phoneNumberInput errorInput"
                                                      : "phoneNumberInput "
                                                  }
                                                  value={element.phone_number}
                                                  onChange={(value, country) =>
                                                    handlePhoneNumberChange(
                                                      value,
                                                      country,
                                                      index
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                            {element.phone_type === "work" && (
                                              <div className="extension-input-wrapper">
                                                <FormInput
                                                  type="number"
                                                  name={`phone_extension_${index}`}
                                                  placeholder="Enter Phone Extension"
                                                  value={
                                                    element.phone_extension ||
                                                    ""
                                                  }
                                                  handleChange={(e) =>
                                                    handlePhoneExtensionChange(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                />
                                              </div>
                                            )}
                                          </div>
                                          <div className="removePhonutBtnWrapper">
                                            <Button
                                              variant="danger"
                                              onClick={() =>
                                                removePhoneFormField(index)
                                              }
                                            >
                                              <FiTrash2 />
                                            </Button>
                                          </div>
                                        </div>
                                        <p className="errorText">
                                          {errors[`phone_number${index}`]}
                                        </p>
                                      </div>

                                      {element.phone_type === "custom" && (
                                        <div
                                          className="formInputWrapper"
                                          style={{ marginTop: "0px" }}
                                        >
                                          <label className="inputLabel">
                                            Custom Label
                                          </label>
                                          <FormInput
                                            type="text"
                                            name={errors[`lable${index}`]}
                                            placeholder={`Enter Phone Label`}
                                            error={errors[`lable${index}`]}
                                            onChange={(e) =>
                                              handleCustomLabel(e, index)
                                            }
                                          />
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                          </div>
                        </div>
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 9
                              : tabValue === 7
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="cardBodyWrapper">
                          <Button
                            className="mb-4"
                            type="button"
                            onClick={handleMediaOpen}
                          >
                            <MdAddBox /> Add Social Link
                          </Button>
                          <div className="socialMediaList">
                            {cardFunction.card_social_media.map(
                              (single, index) => (
                                <div
                                  className="socialMediaLink d-flex justify-content-between align-items-center gap-2 mt-2 card flex-row border py-1 px-2"
                                  key={`cardLink${index}`}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="socialMediaModalLinkIcon">
                                      {single.icon === "custom"
                                        ? single.custom_label.charAt(0)
                                        : single.icon}
                                    </div>
                                    <span>{single.url}</span>
                                  </div>
                                  <Button
                                    variant="danger"
                                    onClick={() => handleMediaDelete(index)}
                                  >
                                    <FiTrash2 className="socialLinkDeleteIcon" />
                                  </Button>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        className="functionStepWrapper"
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 10
                              : tabValue === 8
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="row gx-3 shape-wrapper">
                          {cardViewOptions.map((option) => (
                            <div className="col-lg-2" key={option.value}>
                              <div
                                className={`shape-card d-flex align-items-center ${selectedView === option.value
                                  ? "highlight-view"
                                  : ""
                                  }`}
                                onClick={() =>
                                  handleCardViewChange(option.value)
                                }
                              >
                                {/* <img
                                  src={
                                    cardFunction.profile_image
                                      ? `${URL.createObjectURL(
                                          cardFunction.profile_image
                                        )}`
                                      : pictureicon
                                  }
                                  alt=""
                                  className={classes.viewImage}
                                  onClick={() =>
                                    handleCardViewChange(option.value)
                                  }
                                /> */}
                                {/* <img
                                  src={option.image}
                                  alt=""
                                  className="viewImage w-25"
                                  onClick={() =>
                                    handleCardViewChange(option.value)
                                  }
                                /> */}
                                {option.image}
                                <p className="ms-3">{option.label}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div
                        style={
                          (
                            cardFunction.card_type === "business"
                              ? tabValue === 11
                              : tabValue === 9
                          )
                            ? null
                            : { display: "none" }
                        }
                      >
                        <div className="cardBodyWrapper">
                          <div className="text-center">
                            <div>
                              <img
                                src={cardsuccess}
                                alt=""
                                className="formImage"
                              />
                            </div>
                            <span className="successTitle">Successfully</span>
                            {/* <Button
                              style={{ background: "var(--primary_button_color)", border: 0 }}
                              type="submit"
                              onClick={handleSubmit}
                            >
                              Save
                            </Button> */}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* <div className="mobileViewBtns">
                  <button
                    onClick={handleTabDecrement}
                    className="mobilePrevBtn"
                    disabled={
                      tabValue === 0 ||
                      (cardFunction.card_type === "business"
                        ? tabValue === 11
                        : tabValue === 9)
                    }
                  >
                    <BsArrowLeft />
                  </button>

                  <button
                    onClick={handleTabIncrement}
                    disabled={
                      cardFunction.card_type === "business"
                        ? tabValue === 10 || tabValue === 11
                          ? true
                          : false
                        : tabValue === 8 || tabValue === 9
                        ? true
                        : false
                    }
                  >
                    <BsArrowRight />
                  </button>
                </div> */}
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12 cardView">
            {/* <Card
              data={{
                ...cardFunction,
                pronouns:
                  cardFunction.pronouns === "custom"
                    ? customPronoun
                    : cardFunction.pronouns,
              }}
              handleClose={handleHideCardView}
            /> */}
            {selectedCardView === "list" && (
              <div>
                <Card
                  data={{
                    ...cardFunction,
                    pronouns:
                      cardFunction.pronouns === "custom"
                        ? customPronoun
                        : cardFunction.pronouns,
                  }}
                  handleClose={handleHideCardView}
                  content_view_type={selectedStyleClass}
                  profile_image_shape={selectedShapeClass}
                  logo_shape={selectedShapeClass}
                  preferCardBackground={true}
                  preferCardColor={true}
                  preferCardLogo={true}
                />
              </div>
            )}

            {selectedCardView === "grid" && (
              <div>
                <Card
                  data={{
                    ...cardFunction,
                    pronouns:
                      cardFunction.pronouns === "custom"
                        ? customPronoun
                        : cardFunction.pronouns,
                  }}
                  handleClose={handleHideCardView}
                  content_view_type={selectedStyleClass}
                  profile_image_shape={selectedShapeClass}
                  logo_shape={selectedShapeClass}
                  preferCardBackground={true}
                  preferCardColor={true}
                  preferCardLogo={true}
                />
              </div>
            )}

            {selectedCardView === "tree" && (
              <div>
                <Card
                  data={{
                    ...cardFunction,
                    pronouns:
                      cardFunction.pronouns === "custom"
                        ? customPronoun
                        : cardFunction.pronouns,
                  }}
                  handleClose={handleHideCardView}
                  content_view_type={selectedStyleClass}
                  profile_image_shape={selectedShapeClass}
                  logo_shape={selectedShapeClass}
                  preferCardBackground={true}
                  preferCardColor={true}
                  preferCardLogo={true}
                />
              </div>
            )}

            {selectedCardView === "icon" && (
              <div>
                <Card
                  data={{
                    ...cardFunction,
                    pronouns:
                      cardFunction.pronouns === "custom"
                        ? customPronoun
                        : cardFunction.pronouns,
                  }}
                  handleClose={handleHideCardView}
                  content_view_type={selectedStyleClass}
                  profile_image_shape={selectedShapeClass}
                  logo_shape={selectedShapeClass}
                  preferCardBackground={true}
                  preferCardColor={true}
                  preferCardLogo={true}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <Loader />
      )}

      <Modal
        show={customMediaLinkOpen}
        onHide={handleCustomMediaModalClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal square-modal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader modalHeader flex justify-end">
          <span>Custom Media Link Name</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleCustomMediaModalClose}
          />
          {/* <GrClose onClick={handleUploadImageClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <FormInput
            type="text"
            placeholder="Custom Link Name"
            value={customMediaLink}
            handleChange={(e) => setCustomMediaLink(e.target.value)}
            error={customMediaLinkError.customMediaLink}
          />
        </Modal.Body>

        <Modal.Footer className="mediaModalFooter">
          <button onClick={handleCustomMediaNameSave}>Confirm</button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={mediaOpen}
        onHide={handleMediaClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal square-modal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader flex justify-content-between">
          <span>Social Links</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleMediaClose}
          />
          {/* <GrClose onClick={handleMediaClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <p>
            Add your social links that will be visible on the homepage of your
            blog.
          </p>
          {/* <div className={classes.social}>
            <div className={classes.socialMediaAddButton} onClick={handleClick}>
              <span>Add Social Link</span>
              {socialListOpen ? (
                <BiChevronUp className={classes.arrow} />
              ) : (
                <BiChevronDown className={classes.arrow} />
              )}
            </div>

            {socialListOpen && (
              <div className={classes.socialList}>
                {filteredMediaLinks.map((single, index) => {
                  return (
                    <p className={classes.socialData}>
                      {renderSwitch(single.name)}
                    </p>
                  );
                })}
              </div>
            )}
          </div> */}

          {/* <div
            className={classes.socialMediaModalLink}
            // key={`cardModalLink${index}`}
            // style={
            //   mediaLinkErrors[`${index}.url`]
            //     ? { borderColor: "#e35252" }
            //     : null
            // }
          >
            <div className={classes.socialMediaModalLinkIcon}>
              {single.icon === "custom"
                ? single.custom_label.charAt(0)
                : single.icon}
            </div>
            <input
              defaultValue={inputValue}
              placeholder="Url"
              //onChange={(e) => handleModalUrlChange(e, index)}
              value={inputValue}
            ></input>
            <FiTrash2
              // onClick={() => handleModalMediaDelete(index)}
              className={classes.socialLinkDeleteIcon}
            />
          </div> */}
          {/* <select
            className={classes.select}
            value=""
            onChange={handleMediaChange}
          >
            <option value="" selected disabled>
              Add Social Link
            </option>
            
          </select> */}
          <div className="form-group my-4">
            <Select
              placeholder="Add Social Link"
              options={filteredMediaLinks}
              onChange={(e) => {
                handleMediaChange(e);
              }}
              labelKey="name"
              valueKey="name"
              className="form-select"
            />
          </div>

          {modalMediaLinks.map((single, index) => (
            <>
              <div
                className="socialMediaModalLink d-flex gap-2 form-group align-items-center"
                key={`cardModalLink${index}`}
                style={
                  mediaLinkErrors[`${index}.url`]
                    ? { borderColor: "#e35252" }
                    : null
                }
              >
                <div className="socialMediaModalLinkIcon">
                  {single.icon === "custom"
                    ? single.custom_label.charAt(0)
                    : single.icon}
                </div>
                <input
                  defaultValue={single.url}
                  placeholder="Url"
                  onChange={(e) => handleModalUrlChange(e, index)}
                  className="form-control"
                ></input>
                {/* <FiTrash2
                  className="socialLinkDeleteIcon"
                /> */}
                <Button
                  variant="danger"
                  onClick={() => handleModalMediaDelete(index)}
                >
                  <FiTrash2 />
                </Button>
              </div>
              {mediaLinkErrors[`${index}.url`] ? (
                <div style={{ textAlign: "start" }}>
                  <span className="errorText">
                    {mediaLinkErrors[`${index}.url`]}
                  </span>
                </div>
              ) : null}
            </>
          ))}
        </Modal.Body>

        <Modal.Footer className="mediaModalFooter">
          <Button variant="primary" onClick={handleMedialSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={uploadImageOpen}
        onHide={handleUploadImageClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal square-modal`}
        size="sm"
      >
        <Modal.Header className="modalHeader flex justify-end">
          <span>Upload</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleUploadImageClose}
          />
          {/* <GrClose onClick={handleUploadImageClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div
              className={`d-flex justify-content-center align-items-center flex-column imageUpload`}
            >
              <BsImageFill />
              <span>
                Drop your Images here, or <span>Browse</span>
              </span>
              <span>Support JPG, PNG, Only</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={colorPickerOpen}
        onHide={handleColorPickerClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal square-modal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader modalHeader flex justify-end">
          <span>Color Picker</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleColorPickerClose}
          />
          {/* <GrClose onClick={handleColorPickerClose} /> */}
        </Modal.Header>

        <Modal.Body className={`d-flex justify-content-center mediaModalBody`}>
          <SketchPicker
            color={cardFunction.color}
            onChangeComplete={(color) => {
              handleCustomCardColorChange(color.hex);
            }}
          />
        </Modal.Body>
      </Modal>

      <style type="text/css">
        {`
          .highlight-shape, .highlight-view{
            border: 1px solid var(--blue-color);
          }
          .highlight-shape p, .highlight-view p{
            color: var(--blue-color);
          }
          .btn-holder {
            justify-content: flex-end;
            display: flex;
          }
          .phoneNumberInput {
            font-size: 14px !important;
          }
          .addPhoneInput .react-tel-input .form-control{
            padding: 18.5px 5px 18.5px 52px;
            border: 0 !important;
            width:100%
          }

          .react-tel-input .selected-flag{
                padding: 0 0 0 12px;
          }
          .customSelect.form-select{
            padding: 9px 14px;

          }
          .phoneInputWrapper{
              border: 2px solid var(--border_color);
              border-radius: 25px;
          }
          .phoneInputWrapper.errorInput {
            border: 2px solid #e35252 !important;
          }
          .phoneInputWrapper:focus-within {
            border: 2px solid var(--primary_button_color);
          }
          .addCardSelect.globalInputWithIcon{
            border: 0 !important;
            border-radius: 0;
            border-right: 2px solid var(--border_color) !important;
          }
          .listDesign {
            //background-color: #e1e17d;
          }
          
          .gridDesign .contactInfoInner {
            display: flex;
            flex-wrap: wrap;
            justify-content:space-between;
          }
          .gridDesign .infoContnt {
            width: 48%;
            flex: 0 0 auto;
            padding: 0.5rem;
            display: block;
            text-align: center;
            border:1px solid var(--tertiary_color);
            background:#fff;
            border-radius: 5px;
          }
          .gridDesign .infoContnt a{
            // white-space:normal;
            // display: inline-flex;
            word-break: break-word;
          }
          .gridDesign .contactInfo h6{
            width:100%;
          }
          .gridDesign .moreInfoIcon{
            max-width:38px;
            max-height:38px;
            margin:0 0 10px;
          }
          .treeDesign .contactInfoInner{position:relative;padding-left:15px}
          .treeDesign .contactInfoInner:before{
            content:"";
            border-left: 1px solid #B2B2B2;
            height: 100%;
            position: absolute;
            top: 13px;
            left: 0px;
          }
          .treeDesign .contactInfoInner h6{
            background-color: #DBDBDB;
            padding: 0.2rem 0.75rem;
            display:inline-block;
          }
          .treeDesign .contactInfoInner h6, .treeDesign .contactInfoInner .infoContnt{
            position:relative;
          }
          .treeDesign .contactInfoInner h6:before{
            content:"";
            width: 15px;
            position: absolute;
            left: -15px;
            top: 0px;
            bottom: 0;
            height: 1px;
            margin: auto;
            background-color: #B2B2B2;
          }
          .treeDesign .contactInfoInner .infoContnt:before{
            content:"";
            width: 15px;
            position: absolute;
            height: 1px;
            background-color: #B2B2B2;
            left: -15px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
          .treeDesign .contactInfoInner .infoContnt:after{
            content:"";
            width: 5px;
            height: 5px;
            background-color: #B2B2B2;
            border-radius: 50%;
            position: absolute;
            left: -2.4%;
          }
          .iconDesign .contactInfoInner{
            display:flex;
            flex-wrap:wrap;
          }
          .iconDesign .contactInfo h6{
            width:100%;
          }
          .iconDesign .contactInfoInner .infoContnt{
            width:30.33333%;
            flex: 0 0 auto;
            margin-right:3%;
          }
          .iconDesign .contactInfoInner .infoContnt .moreInfoIcon{
            display:none;
          }
          .iconDesign .contactInfoInner .infoContnt .subHeading{
            display:none;
          }
          .profileImg.circle div,
          .profileImg.circle img {
            border-radius: 50%;
            transition: 0.5s all ease;
          }
          .profileImg.square div,
          .profileImg.square img {
            border-radius: 2px;
            transition: 0.5s all ease;
          }
          .profileImg.rectangular div,
          .profileImg.rectangular img {
            border-radius: 2px;
            width: 90px;
            height: 65px;
            transition: 0.5s all ease;
          }
          .logoWrapper.circle div,
          .logoWrapper.circle img {
            border-radius: 50%;
            transition: 0.5s all ease;
          }
          .logoWrapper.square div,
          .logoWrapper.square img {
            border-radius: 2px;
            transition: 0.5s all ease;
          }
          .logoWrapper.rectangular div,
          .logoWrapper.rectangular img {
            border-radius: 2px;
            width: 50px;
            height: 25px;
            transition: 0.5s all ease;
          }
        `}
      </style>

      {preview && (
        <CropImageModal
          show={showModal}
          image={preview}
          handleCloseModal={handleCloseModal}
          result={result}
          setResult={setResult}
          setFileData={setFileData}
          crop={crop}
          setCrop={setCrop}
        />
      )}
    </>
  );
};

export default CardFunctions;
